import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const OffersLearnApi = createAsyncThunk(
  'OffersLearnApi',
  async (repaymentPayload, { dispatch }) => {
    dispatch({ type: 'OffersLearnApi/pending', payload: {} });

    const { customerId, Authorization, customerRefNum } = repaymentPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerdashboard/other-sections',
      payload: {
        customerRefNum,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const offerLearnResp = res;
        dispatch({ type: 'OffersLearnApi/fulfilled', payload: offerLearnResp });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'OffersLearnApi/rejected', payload: err });
      },
    });
  }
);

export const OffersLearnApi_extrareducer = {
  [OffersLearnApi.pending]: (state, action) => {
    state.offersLearnApiState.isLoading = true;
  },
  [OffersLearnApi.fulfilled]: (state, action) => {
    state.offersLearnApiState.isLoading = false;
    state.offersLearnApiState.isSuccess = true;
    state.offersLearnApiState.isError = false;
    state.offersLearnApiState.response = action.payload;
  },
  [OffersLearnApi.rejected]: (state, action) => {
    state.offersLearnApiState.isLoading = false;
    state.offersLearnApiState.isSuccess = false;
    state.offersLearnApiState.isError = true;
    state.offersLearnApiState.response = action.payload;
  },
};
